import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "short_logo",
  "use": "short_logo-usage",
  "viewBox": "0 0 17 23",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 23\" id=\"short_logo\"><path d=\"M15.436 0v15.734H3.393v1.57h12.043v4.76h1.53V0h-1.53z\" /><path d=\"M4.65 12.236H3.232v1.566H4.65c3.73 0 6.764-3.096 6.764-6.901C11.414 3.096 8.38 0 4.65 0H0v22.064h1.535V1.566h3.118c2.884 0 5.229 2.395 5.229 5.335s-2.348 5.335-5.232 5.335z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol